import { isEmpty } from 'lodash-es';
import { LOCALISATION_SELECTED } from '@/consts/storage';
import { createI18n, type I18n } from 'vue-i18n';

export const SUPPORT_LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof SUPPORT_LOCALES)[number];

let localisationSelected: Locale = 'en';
try {
    localisationSelected =
        (localStorage.getItem(LOCALISATION_SELECTED) as Locale) || 'en';
} catch {
    // localStorage.getItem may not be available in test environments
}
export const i18n = createI18n({ legacy: false, locale: localisationSelected });

if (i18n)
    (async () => {
        await setI18nLanguage(localisationSelected);
    })();

export async function setI18nLanguage(locale: Locale): Promise<I18n> {
    i18n.global.locale.value = locale;
    document.querySelector('html')?.setAttribute('lang', locale);
    document.documentElement.setAttribute(
        'dir',
        i18n.global.locale.value === 'ar' ? 'rtl' : 'ltr',
    );
    await loadLocaleMessages(locale);

    return i18n;
}

async function loadLocaleMessages(locale: Locale) {
    if (!locale) return;

    const messages = await import(
        /* We could've loaded module by module but that was going to introduce future complexity in views that rely on multiple modules at the same time */
        `./${locale}/index.ts`
    );
    i18n.global.setLocaleMessage(locale, messages.default);
}

export function isLocaleMessagesLoaded(locale: Locale): boolean {
    return !isEmpty(i18n.global.getLocaleMessage(locale));
}
